<template>
    <div>
      <h1 class="text-center mt-10 text-4xl font-bold leading-tight text-[#B38E60]">
        {{ t('Agents.title') }}
      </h1>
      <hr class="my-4 mt-8 border-t-2 border-gray-300 dark:border-yellow-500 w-1/3 mx-auto">
  
      <section class="w-full flex justify-center items-center p-8">
        <div class="max-w-screen-xl px-4 pb-8 mx-auto lg:pb-16">
          <div class="grid grid-cols-3 gap-8 mx-auto text-gray-500 sm:gap-12 sm:grid-cols-3 lg:grid-cols-5 dark:text-gray-400">
  
            <!-- صور وضع الضوء -->
            <a
              class="flex items-center lg:justify-center block dark:hidden"
              target="_blank"
              href="https://example1.com"
              rel="noopener noreferrer"
            >
              <img :src="img1Light" class="w-32" alt="Agent 1 Light">
            </a>
            <a
              class="flex items-center lg:justify-center block dark:hidden"
              target="_blank"
              href="https://example2.com"
              rel="noopener noreferrer"
            >
              <img :src="img2Light" class="w-32" alt="Agent 2 Light">
            </a>
            <a
              class="flex items-center lg:justify-center block dark:hidden"
              target="_blank"
              href="https://example3.com"
              rel="noopener noreferrer"
            >
              <img :src="img3Light" class="w-32" alt="Agent 3 Light">
            </a>
            <a
              class="flex items-center lg:justify-center block dark:hidden"
              target="_blank"
              href="https://example4.com"
              rel="noopener noreferrer"
            >
              <img :src="img4Light" class="w-32" alt="Agent 4 Light">
            </a>
            <a
              class="flex items-center lg:justify-center block dark:hidden"
              target="_blank"
              href="https://example5.com"
              rel="noopener noreferrer"
            >
              <img :src="img5Light" class="w-32" alt="Agent 5 Light">
            </a>
  
            <!-- صور وضع الداكن -->
            <a
              class="flex items-center lg:justify-center hidden dark:flex"
              target="_blank"
              href="https://example1.com"
              rel="noopener noreferrer"
            >
              <img :src="img1Dark" class="w-32" alt="Agent 1 Dark">
            </a>
            <a
              class="flex items-center lg:justify-center hidden dark:flex"
              target="_blank"
              href="https://example2.com"
              rel="noopener noreferrer"
            >
              <img :src="img2Dark" class="w-32" alt="Agent 2 Dark">
            </a>
            <a
              class="flex items-center lg:justify-center hidden dark:flex"
              target="_blank"
              href="https://example3.com"
              rel="noopener noreferrer"
            >
              <img :src="img3Dark" class="w-32" alt="Agent 3 Dark">
            </a>
            <a
              class="flex items-center lg:justify-center hidden dark:flex"
              target="_blank"
              href="https://example4.com"
              rel="noopener noreferrer"
            >
              <img :src="img4Dark" class="w-32" alt="Agent 4 Dark">
            </a>
            <a
              class="flex items-center lg:justify-center hidden dark:flex"
              target="_blank"
              href="https://example5.com"
              rel="noopener noreferrer"
            >
              <img :src="img5Dark" class="w-32" alt="Agent 5 Dark">
            </a>
  
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script setup>
  import { useI18n } from 'vue-i18n';
  const { t } = useI18n();
  
  // استيراد صور وضع الضوء
  import img1Light from '@/assets/Agents/1_light.png';
  import img2Light from '@/assets/Agents/2_light.png';
  import img3Light from '@/assets/Agents/3_light.png';
  import img4Light from '@/assets/Agents/4_light.png';
  import img5Light from '@/assets/Agents/5_light.png';
  
  // استيراد صور وضع الداكن
  import img1Dark from '@/assets/Agents/1_dark.png';
  import img2Dark from '@/assets/Agents/2_dark.png';
  import img3Dark from '@/assets/Agents/3_dark.png';
  import img4Dark from '@/assets/Agents/4_dark.png';
  import img5Dark from '@/assets/Agents/5_dark.png';
  </script>
  